import type { ConceptDef } from '../types';

export const sentenceToPicture: ConceptDef = {
  kind: 'tileMatch',
  id: 'sentence-to-picture',
  label: 'Sentence-to-Picture',
  category: 'Literacy',
  description: 'Hear a sentence; tap the picture that matches.',
  config: {
    promptMode: 'AUDIO',
    tileCount: 4,
    items: [
      { say: 'The dog runs.', answer: '🐶 running' },
      { say: 'The cat sleeps.', answer: '🐱 sleeping' },
      { say: 'The bird flies.', answer: '🐦 flying' },
      { say: 'The fish swims.', answer: '🐟 swimming' },
      { say: 'The sun shines.', answer: '🌞 shining' },
    ],
  },
};
